<template>
  <section>
    <div v-if="loading">
      <div class="grid grid-cols-12 gap-6 mt-5">
        <div class="intro-y col-span-12 lg:col-span-12">
          <div class="intro-y box">
            <div
              class="flex flex-col sm:flex-row items-center p-5 border-b border-gray-200"
            >
              <h2 class="font-medium text-base mr-auto">Crear Presupuesto</h2>
            </div>
            <div
              class="mx-2 mt-4"
              v-if="filteredSocialReasonsWithoutTrm.length"
            >
              <div
                class="flex flex-col bg-red-200 rounded-lg p-4 mb-2 text-sm text-red-700"
                role="alert"
              >
                <div class="flex mb-2">
                  <svg
                    class="w-5 h-5 inline mr-3"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                      clip-rule="evenodd"
                    ></path>
                  </svg>
                  <span class="font-medium"
                    >Algunas razones sociales no tienen Trm para este mes:
                  </span>
                </div>
                <ul
                  class="list-disc list-inside"
                  v-for="socialreason in filteredSocialReasonsWithoutTrm"
                  :key="`${socialreason.id}`"
                >
                  <li class="font-medium">
                    {{ socialreason.name }} - {{ socialreason.country_prefix }}
                  </li>
                </ul>
                <a
                  class="underline font-bold mt-2 hover:text-red-600"
                  :href="'/admin/business/social-reasons'"
                  >Ir a Razones Sociales</a
                >
              </div>
            </div>
            <form
              class="intro-y grid grid-cols-12 gap-3 p-5"
              @submit.prevent="checkBudget"
            >
              <div
                v-if="budget.social_reason_id"
                class="mt-3 col-span-6 sm:col-span-6"
              >
                <label>Moneda cambio</label>
                <div class="input w-full border mt-2 flex-1 bg-gray-200">
                  {{ budget.money_code }}
                </div>
              </div>
              <div
                v-if="budget.social_reason_id"
                class="mt-3 col-span-6 sm:col-span-6"
              >
                <label>1 dólar es igual a:</label>
                <div class="input w-full border mt-2 flex-1 bg-gray-200">
                  {{ budget.usd_convertion }}
                </div>
              </div>

              <div class="mt-3 col-span-12 sm:col-span-12 md:col-span-6">
                <label>Razon Social</label>
                <select
                  class="input w-full border mt-2 flex-1"
                  v-model="budget.social_reason_id"
                  required
                  @change="
                    resetBudgetItems('social_reason_id')
                    selectSocialReason()
                  "
                  :disabled="checked"
                >
                  <option seleted :value="null">
                    Seleccione la Razon Social
                  </option>
                  <option
                    v-for="socialreason in socialreasons"
                    :value="socialreason.id"
                    :key="`${socialreason.id}-social-reason`"
                  >
                    {{ socialreason.name }} - {{ socialreason.country_prefix }}
                  </option>
                </select>
              </div>

              <div class="mt-3 col-span-6 sm:col-span-6">
                <label>Referencia</label>
                <input
                  type="text"
                  class="input w-full border mt-2"
                  v-model="budget.reference"
                  required
                  :disabled="checked"
                />
              </div>

              <div
                class="mt-3 col-span-12 sm:col-span-12 md:col-span-6"
                v-if="budget.social_reason_id"
              >
                <label>Cliente</label>
                <select
                  class="input w-full border mt-2 flex-1"
                  v-model="budget.client_id"
                  @change="accountsClient()"
                  required
                  :disabled="checked"
                >
                  <option seleted :value="null">Seleccione Cliente...</option>
                  <option
                    v-for="client in filteredClients"
                    :value="client.id"
                    :key="`${client.id}-client`"
                  >
                    {{ client.social_reason }} ({{ client.accounts.length }}
                    Cuentas)
                  </option>
                </select>
              </div>

              <div
                class="mt-3 col-span-12 sm:col-span-12 md:col-span-6"
                v-if="budget.client_id"
              >
                <label>Cuenta</label>
                <select
                  class="input w-full border mt-2 flex-1"
                  v-model="budget.account_id"
                  required
                  :disabled="!budget.social_reason_id || checked"
                  @change="resetBudgetItems('account_id')"
                >
                  <option seleted :value="null">Seleccione una cuenta</option>
                  <option
                    v-for="account in accounts_client"
                    :value="account.id"
                    :key="`${account.id}-account`"
                  >
                    {{ account.name }}
                  </option>
                </select>
              </div>

              <div
                class="mt-3 col-span-12 sm:col-span-12 md:col-span-6"
                v-if="budget.account_id"
              >
                <label>Director</label>
                <select
                  class="input w-full border mt-2 flex-1"
                  v-model="budget.ejecutive_id"
                  required
                  :disabled="checked"
                >
                  <option seleted :value="null">Seleccione Director...</option>
                  <option
                    v-for="ejecutive in filteredEjecutives"
                    :value="ejecutive.id"
                    :key="`${ejecutive.id}-ejecutive`"
                  >
                    {{ ejecutive.name }} - {{ ejecutive.email }}
                  </option>
                </select>
              </div>

              <div
                class="mt-3 col-span-12 sm:col-span-12 md:col-span-6"
                v-if="budget.ejecutive_id"
              >
                <label>Proyecto</label>
                <select
                  class="input w-full border mt-2 flex-1"
                  v-model="budget.project_id"
                  required
                  :disabled="!budget.account_id || checked"
                >
                  <option seleted :value="null">Seleccione un proyecto</option>
                  <option
                    v-for="project in filteredProjects"
                    :value="project.id"
                    :key="`${project.id}-project`"
                  >
                    {{ project.name }} - {{ project.account.name }}
                    {{ project.account.country.prefix }}
                  </option>
                </select>
              </div>
              <div
                class="mt-3 col-span-12 sm:col-span-12 md:col-span-6"
                v-if="budget.project_id"
              >
                <label>Campaña</label>
                <select
                  class="input w-full border mt-2 flex-1"
                  v-model="budget.campaign_id"
                  required
                  :disabled="!budget.project_id || checked"
                >
                  <option seleted :value="null">Seleccione la campaña</option>
                  <option
                    v-for="campaign in filteredCampaigns"
                    :value="campaign.id"
                    :key="`${campaign.id}-campaign`"
                  >
                    {{ campaign.name }}
                  </option>
                </select>
              </div>
              <div
                class="mt-3 col-span-12 sm:col-span-12 md:col-span-6"
                v-if="budget.campaign_id"
              >
                <label>Tipo de presupuesto</label>
                <select
                  class="input w-full border mt-2 flex-1"
                  v-model="budget.type"
                  required
                  :disabled="checked"
                >
                  <option seleted value="null">Seleccione tipo</option>
                  <option value="cliente">Cliente</option>
                  <option value="cargo agencia">Cargo Agencia</option>
                </select>
              </div>
              <div
                class="mt-3 col-span-12 sm:col-span-12 md:col-span-6"
                v-if="budget.type"
              >
                <label>Comision Agencia</label>
                <input
                  type="number"
                  class="input w-full border mt-2 flex-1"
                  step=".01"
                  v-model="budget.commission_agency"
                  required
                  :disabled="checked"
                />
              </div>
              <div class="col-span-12" v-if="budget.type">
                <div class="px-5 sm:px-8 py-5 sm:py-10">
                  <div class="overflow-x-auto">
                    <table class="table table-custom">
                      <thead>
                        <tr class="border-b dark:border-dark-5">
                          <th class="whitespace-nowrap text-center p-1">
                            CONCEPTO ITEM
                          </th>
                          <th class="whitespace-nowrap text-center">QTY</th>
                          <th class="whitespace-nowrap text-center">
                            VALOR UNITARIO
                          </th>
                          <th class="whitespace-nowrap text-center">IVA</th>
                          <th class="whitespace-nowrap text-center">
                            COMISION
                          </th>
                          <th class="whitespace-nowrap text-center">TOTAL</th>
                          <th class="whitespace-nowrap text-center">
                            V INTERNO/PROVEEDOR
                          </th>
                          <th class="whitespace-nowrap text-center">
                            ACCIONES
                          </th>
                        </tr>
                      </thead>
                      <tbody v-if="!budgetitems.length">
                        <tr>
                          <th colspan="8" class="text-center">
                            No hay Elementos seleccionados
                          </th>
                        </tr>
                      </tbody>
                      <tbody
                        v-for="(item, index) in budgetitems"
                        :key="`${item.name}-budget-item-${index}`"
                        class="border-b dark:border-dark-5"
                      >
                        <tr>
                          <td>
                            <input
                              v-if="!checked"
                              class="input w-full border mt-2"
                              type="text"
                              v-model.lazy="item.name"
                            />
                            <div v-else class="font-medium whitespace-nowrap">
                              {{ item.name }}
                            </div>
                          </td>
                          <td class="text-right">
                            <input
                              v-if="!checked"
                              v-model="item.quantity"
                              type="number"
                              class="input w-20 border mt-auto flex-1"
                              min="1"
                            />
                            <div
                              v-else
                              class="font-medium whitespace-nowrap text-center"
                            >
                              {{ item.quantity }}
                            </div>
                          </td>
                          <td class="text-right">
                            <currency-input
                              :id="item.id"
                              v-if="!checked"
                              class="input w-full border mt-2 text-center"
                              v-model="item.unit_value"
                              locale="es"
                              :precision="5"
                              :valueRange="{ min: 0 }"
                              :distraction-free="{
                                hideNegligibleDecimalDigits: true,
                              }"
                              :currency="{ prefix: '$ ' }"
                              @blur="
                                item.unit_value == null
                                  ? (item.unit_value = 0)
                                  : ''
                              "
                            />
                            <div
                              v-else
                              class="font-medium whitespace-nowrap text-center"
                            >
                              ${{ formatPrice(item.unit_value) }}
                            </div>
                            <div class="mt-3">
                              <div class="text-center">SUBTOTAL:</div>
                              <div class="text-center">
                                $
                                {{
                                  formatPrice(item.quantity * item.unit_value)
                                }}
                              </div>
                            </div>
                          </td>
                          <td class="text-right">
                            <select
                              v-if="!checked"
                              name=""
                              class="input w-full border mt-auto flex-1"
                              v-model="item.iva"
                            >
                              <option :value="0">0%</option>
                              <option
                                v-if="selectedSocialReason.iva"
                                :value="selectedSocialReason.iva"
                              >
                                {{ selectedSocialReason.iva }}%
                              </option>
                            </select>
                            <div
                              v-else
                              class="font-medium whitespace-nowrap text-center"
                            >
                              {{ item.iva }}%
                            </div>
                            <div class="mt-3">
                              <div class="text-center whitespace-no-wrap">
                                VALOR:
                              </div>
                              <div class="text-center whitespace-no-wrap">
                                $
                                {{
                                  formatPrice(
                                    percentCalculator(
                                      item.iva,
                                      item.quantity * item.unit_value
                                    )
                                  )
                                }}
                              </div>
                            </div>
                          </td>
                          <td class="text-right">
                            <select
                              v-if="!checked"
                              name=""
                              class="input w-full border mt-auto flex-1 text-center"
                              v-model="item.commission"
                            >
                              <option :value="0">0%</option>
                              <option :value="1">1%</option>
                              <option :value="2.5">2,5%</option>
                              <option :value="3">3%</option>
                              <option :value="3.2">3,2%</option>
                              <option :value="4">4%</option>
                              <option :value="4.2">4,2%</option>
                              <option :value="6">6%</option>
                              <option :value="7.2">7,2%</option>
                              <option :value="8">8%</option>
                            </select>
                            <div
                              v-else
                              class="font-medium whitespace-nowrap text-center"
                            >
                              {{ item.commission }}%
                            </div>
                            <div class="mt-3">
                              <div class="text-center whitespace-no-wrap">
                                VALOR:
                              </div>
                              <div class="text-center whitespace-no-wrap">
                                $
                                {{
                                  formatPrice(
                                    percentCalculator(
                                      item.commission,
                                      item.quantity * item.unit_value
                                    )
                                  )
                                }}
                              </div>
                            </div>
                          </td>
                          <td class="text-right">
                            <div class="whitespace-no-wrap text-center">
                              $
                              {{
                                formatPrice(
                                  item.quantity * item.unit_value +
                                    percentCalculator(
                                      item.iva,
                                      item.quantity * item.unit_value,
                                      false
                                    ) +
                                    percentCalculator(
                                      item.commission,
                                      item.quantity * item.unit_value,
                                      false
                                    )
                                )
                              }}
                            </div>
                          </td>
                          <td class="text-center">
                            <div class="flex flex-col">
                              <currency-input
                                :id="item.id"
                                v-if="!checked"
                                class="input w-full border mt-2 text-center"
                                v-model="item.unit_value_internal"
                                locale="es"
                                :precision="5"
                                :valueRange="{ min: 0 }"
                                :distraction-free="{
                                  hideNegligibleDecimalDigits: true,
                                }"
                                :currency="{ prefix: '$ ' }"
                              />
                              <div
                                v-else
                                class="font-medium whitespace-nowrap text-center"
                              >
                                ${{ formatPrice(item.unit_value_internal) }}
                              </div>
                              <select
                                class="input w-full border mt-auto flex-1 text-center"
                                v-model="item.supplier_id"
                                :disabled="checked"
                              >
                                <option :value="null">Seleccionar ...</option>
                                <option
                                  v-for="(supplier, index) in suppliers"
                                  :value="supplier.id"
                                  :key="`${supplier.id}-${index}-supplier`"
                                >
                                  {{ supplier.social_reason }}
                                </option>
                              </select>
                            </div>
                          </td>
                          <td class="text-right" rowspan="2">
                            <button
                              @click="budgetitems.splice(index, 1)"
                              type="button"
                              class="button bg-theme-6 text-white mt-auto"
                              v-if="!checked"
                            >
                              Eliminar
                            </button>
                          </td>
                        </tr>
                        <tr>
                          <td class="text-center">DESCRIPCION(*):</td>
                          <td colspan="4">
                            <textarea
                              v-if="!checked"
                              class="input w-full border mt-2"
                              rows="3"
                              v-model="item.description"
                              required
                            ></textarea>
                            <div v-else class="font-medium whitespace-nowrap">
                              {{ item.description }}
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <div
                    class="intro-y grid grid-cols-12 gap-3 py-5 bg-gray-400 px-2 rounded"
                    v-if="!checked"
                  >
                    <div class="mt-3 col-span-12 sm:col-span-12 md:col-span-6">
                      <label>Agregar item:</label>
                      <select
                        class="input w-full border mt-2 flex-1"
                        v-model="budgetCurrentItem.id"
                      >
                        <option seleted :value="null">Seleccione...</option>
                        <option
                          v-for="element in filteredBudgetElements"
                          :value="element.id"
                          :key="`${element.id}-budget-element`"
                        >
                          {{ element.name }} - $
                          {{ formatPrice(element.value) }}
                        </option>
                        <option
                          value="special"
                          v-if="filteredBudgetElements.length"
                        >
                          Nuevo Elemento
                        </option>
                      </select>
                    </div>
                    <div class="mt-3 col-span-12 sm:col-span-12 md:col-span-3">
                      <label>Cantidad:</label>
                      <input
                        v-model="budgetCurrentItem.quantity"
                        type="number"
                        min="1"
                        class="input w-full border mt-2 flex-1"
                      />
                    </div>
                    <div
                      class="mt-3 col-span-12 sm:col-span-12 md:col-span-3 flex"
                    >
                      <button
                        @click="addItem()"
                        type="button"
                        class="button w-24 bg-theme-1 text-white mt-auto"
                        :disabled="!budgetCurrentItem.id"
                      >
                        Agregar
                      </button>
                    </div>
                  </div>

                  <div
                    class="px-5 sm:px-20 pb-10 sm:pb-20 flex flex-col-reverse sm:flex-row"
                  >
                    <div class="text-center sm:text-right sm:ml-auto mt-5">
                      <div class="text-base text-gray-600">
                        Subtotal:
                        <span
                          class="text-lg text-theme-1 dark:text-theme-10 font-medium mt-2"
                        >
                          {{ budget.money_code }} $ {{ formatPrice(subtotal) }}
                        </span>
                      </div>
                      <div v-if="subtotal" class="text-base text-gray-600">
                        Subtotal:
                        <span
                          class="text-lg text-theme-1 dark:text-theme-10 font-medium mt-2"
                        >
                          USD $ {{ formatPrice(budget.usd_subtotal) }}
                        </span>
                      </div>
                      <hr class="my-4" />
                      <div class="text-base text-gray-600">
                        Impuestos subtotal:
                        <span
                          class="text-lg text-theme-1 dark:text-theme-10 font-medium mt-2"
                        >
                          {{ budget.money_code }} $
                          {{ formatPrice(taxSubtotal) }}
                        </span>
                      </div>
                      <div
                        v-if="budget.usd_convertion"
                        class="text-base text-gray-600"
                      >
                        Impuestos subtotal:
                        <span
                          class="text-lg text-theme-1 dark:text-theme-10 font-medium mt-2"
                        >
                          USD $
                          {{ formatPrice(taxSubtotal / budget.usd_convertion) }}
                        </span>
                      </div>
                      <hr class="my-4" />
                      <div class="text-base text-gray-600">
                        Comision subtotal:
                        <span
                          class="text-lg text-theme-1 dark:text-theme-10 font-medium mt-2"
                        >
                          {{ budget.money_code }} $
                          {{ formatPrice(commissionSubtotal) }}
                        </span>
                      </div>
                      <div
                        v-if="budget.usd_convertion"
                        class="text-base text-gray-600"
                      >
                        Comision subtotal:
                        <span
                          class="text-lg text-theme-1 dark:text-theme-10 font-medium mt-2"
                        >
                          USD $
                          {{
                            formatPrice(
                              commissionSubtotal / budget.usd_convertion
                            )
                          }}
                        </span>
                      </div>
                      <hr class="my-4" />
                      <div
                        class="text-xl text-theme-1 dark:text-theme-10 font-medium mt-2"
                      >
                        <span class="text-gray-600">TOTAL:</span>
                        {{ budget.money_code }} $ {{ formatPrice(total) }}
                      </div>
                      <div
                        v-if="total"
                        class="text-xl text-theme-1 dark:text-theme-10 font-medium mt-2"
                      >
                        <span class="text-gray-600">TOTAL: </span>
                        USD $ {{ formatPrice(budget.usd_total) }}
                      </div>
                      <div class="mt-1 tetx-xs">Incluye Impuestos</div>
                    </div>
                  </div>
                </div>
              </div>

              <div v-if="checked" class="mt-3 col-span-12">
                <button
                  type="button"
                  @click="createBudget()"
                  class="button bg-theme-1 text-white mt-auto"
                >
                  Confirmar Presupuesto
                </button>
                <button
                  type="button"
                  @click="checked = false"
                  class="button bg-theme-11 text-white mt-auto"
                >
                  Editar Presupuesto
                </button>
              </div>

              <div v-else class="mt-3 col-span-12">
                <button
                  type="submit"
                  class="button bg-theme-1 text-white mt-auto"
                >
                  Crear Presupuesto
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <app-loading v-else />

    <TrmChangeModal
      :socialreason="selectedSocialReason"
      v-if="boxtrmchange"
      @closeModal="boxtrmchange = false"
      message="No se ha actualizado este mes el TRM"
    />
  </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Loading from '@/components/admin/partials/LoadingWhite'
import TrmChangeModal from '@/components/admin/social-reasons/TrmChangeModal'

export default {
  name: 'CreateBudget',
  data() {
    return {
      loading: false,
      view: {
        entity: 'budget',
        id: this.$route.params.id,
      },
      budgetCurrentItem: this.defineBudgetItem(),
      budgetitems: [],
      budget: this.defineBudget(),
      subtotal: 0,
      total: 0,
      checked: false,
      boxtrmchange: false,
      selectedSocialReason: {},
      country_select_id: null,
      accounts_client: null,
      social_country_id: null,
    }
  },
  computed: {
    ...mapGetters({
      countries: 'getAccountCountries',
      socialreasons: 'getSocialReasons',
      accounts: 'getAccounts',
      campaigns: 'getCampaigns',
      states: 'getBudgetStates',
      user: 'getUser',
      projects: 'getProjects',
      elements: 'getBudgetElements',
      clients: 'getClients',
      ejecutives: 'getUsers',
      suppliers: 'getSuppliers',
    }),
    filteredAccounts() {
      return this.accounts.filter((account) => {
        let social_reason = this.budget.social_reason_id
          ? account.social_reason_id == this.budget.social_reason_id
          : true
        let country = this.country_select_id
          ? item.country_id == this.country_select_id
          : true

        return social_reason && country
      })
    },
    filteredProjects() {
      return this.projects.filter((project) => {
        if (
          project.account_id == this.budget.account_id ||
          project.account_id == this.budget.account_id
        ) {
          return project
        }
      })
    },
    filteredClients() {
      return this.clients.filter((item) => {
        if (item.country_id == this.social_country_id) {
          return item
        }
      })
    },
    filteredCampaigns() {
      return this.campaigns.filter((campaign) => {
        if (
          campaign.project_id == this.budget.project_id ||
          campaign.project_id == this.budget.project_id
        ) {
          return campaign
        }
      })
    },
    filteredBudgetElements() {
      return this.elements.filter((element) => {
        if (
          element.account_id == this.budget.account_id ||
          element.account_id == this.budget.account_id
        ) {
          return element
        }
      })
    },
    filteredEjecutives() {
      return this.ejecutives.filter((ejecutive) => {
        if ([5].includes(ejecutive.roles[0].id)) {
          return ejecutive
        }
      })
    },
    filteredSocialReasonsWithoutTrm() {
      const current_month = new Date().getMonth() + 1
      const current_year = new Date().getFullYear()

      return this.socialreasons.filter((socialreason) => {
        if (
          !this.searchMonth(
            socialreason.trm_change,
            current_month,
            current_year
          )
        ) {
          return socialreason
        }
      })
    },
    taxSubtotal() {
      return this.budgetitems.reduce(
        (acc, item) =>
          acc +
          this.percentCalculator(item.iva, item.quantity * item.unit_value),
        0
      )
    },
    commissionSubtotal() {
      return this.budgetitems.reduce(
        (acc, item) =>
          acc +
          this.percentCalculator(
            item.commission,
            item.quantity * item.unit_value
          ),
        0
      )
    },
  },
  async beforeMount() {
    try {
      await this.getList('accountcountry')
      await this.getList('socialreason')
      await this.getList('account')
      await this.getList('project')
      await this.getList('campaign')
      await this.getList('budgetstate')
      await this.getList('budgetelement')
      await this.getList('client')
      await this.getList('user')
      await this.getAll('supplier')

      this.loading = true
    } catch (error) {}
  },
  methods: {
    defineBudget: () => ({
      client_id: null,
      ejecutive_id: null,

      name: '',
      number: '',
      date: '',
      entity: 'budget',
      path: '',
      created_by: null,

      reference: null,
      type: null,

      country_id: null,
      social_reason_id: null,
      account_id: null,
      project_id: null,
      campaign_id: null,

      money_code: null,
      iva: 0,
      commission: 0,
      usd_convertion: null,
      trm_change_id: null,

      usd_subtotal: 0,
      usd_total: 0,
    }),
    updateSocialReasonConvertion(response) {
      const { trm_change_id, money_code, usd_convertion } = response

      if (!usd_convertion) {
        this.boxtrmchange = true
      }

      this.budget.money_code = money_code
      this.budget.usd_convertion = usd_convertion
      this.budget.trm_change_id = trm_change_id
    },
    defineBudgetItem: () => ({
      id: null,
      quantity: 1,
    }),
    checkBudget() {
      if (!this.budgetitems.length) {
        window.$toast.info('No hay elementos seleccionados')
        return
      }

      if (!this.budget.usd_convertion) {
        window.$toast.info('Actualice las conversiones en la seccion de paises')
        return
      }

      this.checked = true
    },
    selectSocialReason() {
      let response = this.socialreasons.find(
        (socialreason) => socialreason.id == this.budget.social_reason_id
      )
      if (response) {
        this.social_country_id = response.country_id
        this.updateSocialReasonConvertion(response)
        this.selectedSocialReason = response
      } else {
        return {}
      }
    },
    createBudget() {
      if (!this.budgetitems.length) {
        window.$toast.info('No hay elementos seleccionados')
        return
      }

      let vm = this
      vm.budget.created_by = this.user.id
      vm.budget.items = this.budgetitems

      vm.budget.subtotal = this.subtotal
      vm.budget.subtotal_internal = this.subtotal_internal
      vm.budget.total = this.total
      vm.budget.total_internal = this.total_internal
      vm.budget.iva = this.taxSubtotal
      vm.budget.commission = this.commissionSubtotal
      vm.budget.usd_tax = this.taxSubtotal / vm.budget.usd_convertion
      vm.budget.usd_commission =
      this.commissionSubtotal / vm.budget.usd_convertion
      //console.log(vm.budget)
      vm.loading = false
      vm.store(vm.budget)
        .then((item) => {
          vm.$router.replace(
            vm.$route.query.redirect || '/admin/business/budgets'
          )
        })
        .catch((error) => {
          console.log('FAILURE!!')
          vm.loading = true
        })
        .finally(() => {
          vm.loading = true
          this.defineBudget()
        })
    },
    createVersion() {
      var vm = this
      vm.loading = false
      window.$('#create').button('loading')
      vm.version.email_id = this.email.id
      vm.store(vm.version)
        .then((item) => {
          vm.loading = true
          vm.$router.replace(
            vm.$route.query.redirect || '/admin/business/budgets'
          )
        })
        .catch((message) => {
          window.$('#create').button('reset')
          vm.loading = true
        })
    },
    updateVersion(item) {
      var vm = this
      vm.loading = false
      window.$('#editversion').button('loading')
      vm.version_current.id = item.id
      vm.store(vm.version_current)
        .then((item) => {
          vm.loading = true
          vm.$router.replace(
            vm.$route.query.redirect || '/admin/business/budgets'
          )
        })
        .catch((message) => {
          window.$('#editversion').button('reset')
          vm.loading = true
        })
    },
    addItem() {
      let item = this.elements.find(
        (element) => element.id == this.budgetCurrentItem.id
      )

      let object = {
        name: item ? item.name : 'Titulo',
        description: null,
        quantity: parseInt(this.budgetCurrentItem.quantity),
        unit_value: item ? item.value : 0,
        unit_value_internal: item ? item.value : 0,
        iva: 0,
        commission: 0,
        total: null,
        supplier_id: null,
      }
      this.budgetitems.push(object)

      this.budgetCurrentItem = this.defineBudgetItem()
    },
    formatPrice(value) {
      let val = (value / 1).toFixed(5) // 5 decimales
      let [integer, decimal] = val.split('.') // separar partes

      // aplicar separador de miles SOLO al entero
      integer = integer.replace(/\B(?=(\d{3})+(?!\d))/g, '.')

      return integer + ',' + decimal // unir con coma decimal
    },
    percentCalculator(percent, value, totalIncludePercent = false) {
      if (percent) {
        let ivaDecimal = totalIncludePercent
          ? (100 + percent) / 100
          : percent / 100
        return ivaDecimal * value
      }

      if (totalIncludePercent) {
        return value
      }

      return 0
    },
    resetBudgetItems(element) {
      if (element == 'social_reason_id') {
        this.budgetitems = []
        this.budget.account_id = null
        this.budget.project_id = null
      }

      if (element == 'account_id') {
        this.budgetitems = []
        this.budget.project_id = null
      }
    },
    accountsClient() {
      const client = this.clients.find(({ id }) => id === this.budget.client_id)
      this.accounts_client = client.accounts
    },
    searchMonth(trms, month, year) {
      let response = false

      trms.forEach((trm) => {
        if (trm.month == month && trm.year == year) {
          response = true
        }
      })

      return response
    },
    ...mapActions(['show', 'getAll', 'getList', 'update', 'store']),
  },
  watch: {
    budgetitems: {
      deep: true,

      handler(value) {
        this.subtotal = 0
        this.subtotal_internal = 0
        this.total = 0
        this.total_internal = 0
        this.budgetitems.forEach((item) => {
          this.subtotal += item.quantity * item.unit_value
          this.subtotal_internal += item.quantity * item.unit_value_internal
          this.total +=
            item.quantity * item.unit_value +
            this.percentCalculator(
              item.iva,
              item.quantity * item.unit_value,
              false
            ) +
            this.percentCalculator(
              item.commission,
              item.quantity * item.unit_value,
              false
            )
          this.total_internal +=
            item.quantity * item.unit_value_internal +
            this.percentCalculator(
              item.iva,
              item.quantity * item.unit_value_internal,
              false
            ) +
            this.percentCalculator(
              item.commission,
              item.quantity * item.unit_value_internal,
              false
            )
        })

        this.budget.usd_subtotal = this.subtotal / this.budget.usd_convertion
        this.budget.usd_total = this.total / this.budget.usd_convertion
      },
    },
  },
  components: {
    appLoading: Loading,
    TrmChangeModal,
  },
}
</script>



// WEBPACK FOOTER //
// CreateBudget.vue?64749e06